import { Link } from "react-router-dom";

export default function PageHero({ badge, title, subtitle, actions }) {
  return (
    <header className="pm-page-hero">
      <div className="pm-container">
        {badge && (
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            {badge}
          </span>
        )}
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {actions && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            {actions.map((a) =>
              a.external ? (
                <a
                  key={a.label}
                  href={a.to}
                  className={`pm-btn ${a.primary ? "pm-btn-primary" : "pm-btn-outline"}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {a.label}
                </a>
              ) : (
                <Link
                  key={a.label}
                  to={a.to}
                  className={`pm-btn ${a.primary ? "pm-btn-primary" : "pm-btn-outline"}`}
                >
                  {a.label}
                </Link>
              )
            )}
          </div>
        )}
      </div>
    </header>
  );
}
